module.exports = require("./slick/slick.js");
require("./slick/slick.css");


//////////////////
// WEBPACK FOOTER
// slick-carousel (bower component)
// module id = 1229
// module chunks = 1